import { render, staticRenderFns } from "./twofactor-settings.vue?vue&type=template&id=e9b02d18&scoped=true"
import script from "./twofactor-settings.vue?vue&type=script&lang=ts"
export * from "./twofactor-settings.vue?vue&type=script&lang=ts"
import style0 from "./twofactor-settings.vue?vue&type=style&index=0&id=e9b02d18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9b02d18",
  null
  
)

export default component.exports